module.exports = __webpack_public_path__ + "img/form.f936cd57.svg";